import { LocationCoord } from "services/LocationsService";

export type AdaptedLocation = Array<[number, number]>; // leaflet adapted locations

class LocationsAdapter {
  adapt(locations: LocationCoord[]): AdaptedLocation {
    return locations.map((location) => [
      Number(location.lat),
      Number(location.lng),
    ]);
  }
}

export default new LocationsAdapter();
